import { maskDecimal } from '@givebutter/util';
import { EmptyData } from 'components/util';
import { CurrencySymbol } from 'customHooks/useCurrencySymbol';
import { isoDateFromServer } from 'helpers/dates';
import { PledgeActivityResource } from 'types/domain';

interface PledgeContentProps {
    item: PledgeActivityResource;
}

const PledgeContent = ({ item }: PledgeContentProps) => {
    return (
        <div className="flex flex-col justify-between gap-4 md:flex-row">
            <div>
                <p className="text-sm text-gray-600">Total paid</p>
                <p className="font-medium text-black">
                    <CurrencySymbol />
                    {maskDecimal(item.pledge_total_paid)}
                </p>
            </div>
            <div>
                <p className="text-sm text-gray-600">Balance</p>
                <p className="font-medium text-black">
                    <CurrencySymbol />
                    {maskDecimal(item.pledge_balance)}
                </p>
            </div>
            <div>
                <p className="text-sm text-gray-600">Next installment</p>
                <p className="font-medium text-black">
                    {item.pledge_next_installment ? (
                        isoDateFromServer(item.pledge_next_installment).toFormat('dd MMM, yyyy')
                    ) : (
                        <EmptyData />
                    )}
                </p>
            </div>
            <div>
                <p className="text-sm text-gray-600">Installments left</p>
                <p className="font-medium text-black">{item.pledge_installments_left}</p>
            </div>
        </div>
    );
};

export { PledgeContent };
